import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import {Location} from '@angular/common';

import { BasicValidators } from '../shared/basic-validators';
import {BancosModel} from "./bancos.model";
import {BancosService} from './bancos.service';
import {Funcoes} from "../funcoes";
import {Global} from "../global";


@Component({
  selector: 'app-bancos-form',
  templateUrl: './bancos-form.component.html'
})
export class BancosFormComponent implements OnInit {

  form: FormGroup;
  title: string;
  banco: BancosModel = new BancosModel();
  pageIsUpd: boolean = false;
  pageIsAdd: boolean = false;
  enviando = false;

  constructor(
    formBuilder: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private bancosService: BancosService,
    private _location: Location,
    public func: Funcoes,
    public global: Global
  ) {
    this.form = formBuilder.group({
      id_banco: [],
      nome: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(255)
      ]],
      favorecido: ['', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(255)
      ]],
      agencia: [],
      conta: [],
      documento: []
    });
  }

  ngOnInit() {

    // verifica se é uma página de edição
    if(this.router.url.split(/\//).pop() == 'upd'){
      this.pageIsUpd = true;
    }

    // verifica se é uma página para adicionar
    if(this.router.url.split(/\//).pop() == 'add'){
      this.pageIsAdd = true;
    }

    let id = this.route.params.subscribe(params => {
      let id = params['id_banco'];

      if(this.pageIsUpd){
        this.title = this.func.traduzir('front.editarBanco');
      }else{
        this.title = (id) ? this.func.traduzir('front.visualizarBanco') : this.func.traduzir('front.cadastrarNovoBanco');
      }


      if (!id) {
        return;
      }

      this.bancosService.getById(id)
        .subscribe(
          json => {
            if(this.pageIsUpd) {
              this.title = this.func.traduzir('front.editarBanco')+': '+json.Payload[0].nome;
            }else{
              this.title = this.func.traduzir('front.visualizarBanco') + ': ' + json.Payload[0].nome;
            }

            this.banco = json.Payload[0];

            if(this.global.debug == true){
              console.log(json.Payload[0]);
            }
          },
          error => {
            this.func.showErro(error.json());
          });
    });
  }

  voltar() {
    this._location.back();
  }

  save() {
    this.enviando = true;
    let result,
      values = this.form.value;

    if (values.id_banco) {
      result = this.bancosService.editar(values, values.id_banco);
    } else {
      result = this.bancosService.adicionar(values);
    }

    result.subscribe(data => this.router.navigate(['/painel', 'financeiro', 'bancos']),
      error => {
        this.enviando = false;
        this.func.showErro(error.json());
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/bancos/bancos-form.component.ts